import { Theme } from "@emotion/react";

import { TicketStatus } from "@megaron/support-contracts";

export const getSupportTicketListTextColor = (theme: Theme, status: TicketStatus) => {
  if (status === "resolved") return theme.colors.success;
  if (status === "closed") return "black";
  if (status === "pending") return theme.colors.warning;
  return theme.colors.primary;
};
